module.exports = __webpack_public_path__ + "static/media/experiment.8849182b.jpeg";